import { render, staticRenderFns } from "./Sevkiyat.vue?vue&type=template&id=e7007a28&"
import script from "./Sevkiyat.vue?vue&type=script&lang=js&"
export * from "./Sevkiyat.vue?vue&type=script&lang=js&"
import style0 from "./Sevkiyat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports